import view from '../../../view';
import { connectedStore } from '../../../store';
import { DISABLE_BLUR_ATTR } from '../../constants/attributes';

const blurElementOnParentContextClick = (event) => {
  if (!event.view) {
    return;
  }

  const store = connectedStore.get();
  const state = store.getState();

  const focusedElementId = view.selectors.getFocusedElement(state);

  if (!focusedElementId) {
    return;
  }

  const { target } = event;
  const disableBlurElement = target.closest(`[${DISABLE_BLUR_ATTR}]`);
  if (disableBlurElement) return;

  store.dispatch(view.actions.blurFocusedElement({ preserveFocusedTextElement: true }));
};

export default blurElementOnParentContextClick;
